<template>
  <div class="view pa24">
    <el-form :model="searchParams">
      <el-row>
        <el-col :span="8">
          <el-form-item label-width="100px" label-position="left" class="fromItem">
            <el-input v-model="searchParams.name" placeholder="请输入仓库名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col style="margin-left: 15px" :span="14">
          <el-button type="primary" class="myBtn" @click="getMain">搜索</el-button>
          <el-button type="primary" class="myBtn" @click="handleAdd">+添加仓库</el-button>
          <el-button type="primary" class="myBtn" @click="toQuery" icon="el-icon-search">产品检索</el-button>
          <!-- <el-button type="primary" class="myBtn" @click="openStockTakingDialog" :loading="stockTakingLoading">盘库</el-button> -->
        </el-col>
      </el-row>
    </el-form>
    <div v-if="!mainList || mainList.length <=0">
      <el-empty description="暂无数据"></el-empty>
    </div>
    <div class="d-flex" v-else>
      <el-tabs type="border-card" class="tabBox" v-model="mainActive" tab-position="left" @tab-click="selectMain">
        <el-tab-pane :label="item.name" :name="item.id" :key="item.id" v-for="item in mainList">
          <div class="tab-head">
            <label class="tab-head-top">基本信息</label>
          </div>
          <div class="tab-body">
            <div class="tab-body-item">
              <div class="tab-body-item-top">{{item.name}}</div>
              <div>仓库名称</div>
            </div>
            <div class="tab-body-item">
              <div class="tab-body-item-top">{{storeCodeTypeMap[item.warehouseType]}}</div>
              <div>仓库类型</div>
            </div>
            <div class="tab-body-item">
              <div class="tab-body-item-top">{{item.leader}}</div>
              <div>负责人</div>
            </div>
            <div class="tab-body-item">
              <div class="tab-body-item-top">{{item.phone}}</div>
              <div>联系电话</div>
            </div>
            <div class="tab-body-item">
              <div class="tab-body-item-top">{{item.sorting}}</div>
              <div>排序</div>
            </div>
            <div class="tab-body-item">
              <el-button type="primary" @click="edit(item)">修改</el-button>
              <el-button type="danger" @click="del(item)">删除</el-button>
              <!-- 导出 -->
              <el-button type="primary" class="myBtn" v-if="item.warehouseType==0" @click="exportExcle(item.id)">导出</el-button>
            </div>
          </div>
          <div class="tab-area-head">库区列表</div>
          <div class="tab-area-body">
            <el-form :model="queryParam">
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="100px" label-position="left" class="fromItem">
                    <el-input v-model="queryParam.name" placeholder="请输入库区名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col style="margin-left: 15px" :span="6">
                  <el-button type="primary" class="myBtn" @click="getList">搜索</el-button>
                  <el-button type="primary" class="myBtn" @click="handleAddTwo(item)">+添加库区</el-button>
                  <el-button type="primary" class="myBtn" @click="printAll">批量打印</el-button>
                </el-col>
              </el-row>
            </el-form>
            <el-table :data="tableData" class="kqTable" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
              <el-table-column prop="name" align="center" label="库区名称" />
              <el-table-column prop="code" align="center" label="库区二维码" width="120px">
                <template slot-scope="scope">
                  <div :id="`codeImage${scope.row.id}`">
                    <vue-qr :size="200" :margin="10" :auto-color="true" :dot-scale="1"
                      :text="`${codeUrl}?warehouse=${scope.row.id}`" />
                    <div style="font-size: 12px;font-weight: bold">{{scope.row.fullName}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="childrenNum" align="center" label="区位数量">
                <template slot-scope="scope">
                  <el-button @click="showChildren(scope.row)" type="text">
                    <span>{{scope.row.childrenNum||0}}</span>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column prop="sorting" align="center" label="排序" />
              <el-table-column prop="createTime" align="center" label="创建时间" />
              <el-table-column align="center" width="200" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="downTwo(scope.row)">下载二维码</el-button>
                  <el-button type="text" @click="editTwo(scope.row)">编辑</el-button>
                  <el-button type="text" @click="delTwo(scope.row)">删除</el-button>
                  <el-button type="text" @click="printBtn(scope.row)">打印</el-button>
                 <el-button type="text" v-if="item.warehouseType==0"  @click="exportExcle(scope.row.id)">导出</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageBox">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryParam.pageNum" :page-sizes="[10, 15, 20]"
                layout="total, sizes, prev, pager, next, jumper" class="" :total="total" :pager-count="5" />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <add-warehouse-dialog ref="addDialog" @getList="getMain"></add-warehouse-dialog>
    <add-warehouse-dialog ref="addDialogTwo" @getList="getList"></add-warehouse-dialog>
    <warehouse-dialog ref="detailDialog" />
    <location-dialog ref="childrenVisible" @getList="getList"></location-dialog>
    <code-print ref="codePrint"></code-print>
    <query-model-tab ref="modelTab"></query-model-tab>
    <el-dialog
      title="请勾选需要盘点的仓库"
      :visible.sync="stockTakingDialogVisible"
      width="420px"
      append-to-body
      :close-on-click-modal="false"
      @close="cancelStockTakingSelect"
    >
      <div v-if="!mainList || mainList.length <= 0" class="stock-taking-empty">暂无仓库</div>
      <el-checkbox-group v-else v-model="stockTakingIds" class="stock-taking-group">
        <el-checkbox v-for="item in mainList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelStockTakingSelect">取消</el-button>
        <el-button type="primary" :loading="stockTakingLoading" @click="confirmStockTakingExport">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { get } from "@/utils/request";
  import VueQr from 'vue-qr'
  import AddWarehouseDialog from "@/pages/storeWarehouse/component/AddWarehouseDialog.vue";
  import { deleteWarehouse, exportExcles, exportStockTaking } from '@/api/storeWarehouse.js'
  import WarehouseDialog from "@/pages/dashboard/components/detailDialog/warehouseDialog.vue";
  import LocationDialog from "./component/locationDialog.vue";
  import { storeCodeTypeMap } from '@/utils/constant'
  import html2canvas from "html2canvas";
  import CodePrint from "./component/codePrint.vue";
  import { codeUrl } from '@/utils/constant'
  import QueryModelTab from "./component/queryModelTab.vue";
  import { baseUrl } from "@/utils/index"

  export default {
    name: "structureHome",
    components: { QueryModelTab, CodePrint, AddWarehouseDialog, VueQr, WarehouseDialog, LocationDialog },
    data() {
      return {
        codeUrl: codeUrl,
        storeCodeTypeMap: storeCodeTypeMap,
        mainList: [],
        mainActive: '0',
        searchParams: {
          name: ''
        },
        tableData: [],
        loading: false,
        total: 1,
        queryParam: {
          pageSize: 10,
          pageNum: 1,
          type: 1,
          parentId: 0,
          search: '',
          name: ''
        },
        printVisible: false,
        stockTakingLoading: false,
        stockTakingDialogVisible: false,
        stockTakingIds: []
      }
    },
    created() {
      this.getMain()
    },
    methods: {
      toQuery() {
        this.$refs.modelTab.init()
      },
      getMain() {
        const that = this;
        that.mainList = []
        get('/store/warehouse/noPage', { type: 0, parentId: 0, search: this.searchParams.name }).then(res => {
          res.forEach(function (element) {
            // 遍历数组，对每个元素进行操作
            element.id = element.id + ''
            that.mainList.push(element);
          });
          if (res.length > 0 && '0' === this.mainActive) {
            that.mainActive = res[0].id + ""
            that.queryParam.parentId = this.mainActive
          }
          that.getList()
        })
      },
      selectMain(data) {
        this.queryParam.parentId = data.name
        this.mainActive = data.name + ''
        this.getList()
      },
      getList() {
        this.tableData = []
        get('/store/warehouse/page', this.queryParam).then(res => {
          this.tableData = res.list
          this.total = res.total
        })
      },
      showDetail(item) {
        item.isShow = true
        this.$refs.detailDialog.openDialog(item)
      },
      del(data) {
        let params = {
          id: data.id
        }
        this.$confirm('此操作将永久删除该仓库, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteWarehouse(params).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.mainActive = "0"
              this.getMain()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      delTwo(data) {
        let params = {
          id: data.id
        }
        this.$confirm('此操作将永久删除该库区, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteWarehouse(params).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      edit(data) {
        this.$refs.addDialog.openDialog('edit', data)
      },
      downTwo(row) {
        let dom = document.getElementById('codeImage' + row.id);
        html2canvas(dom, { scale: 3 }).then(canvas => {
          let dataURL = canvas.toDataURL("image/png");
          if (dataURL !== "") {
            let a = document.createElement('a')
            a.download = row.name + '.png';
            a.href = dataURL;
            a.click()
          }
        })
      },
      editTwo(data) {
        this.$refs.addDialogTwo.openDialog('edit', data)
      },
      handleAdd() {
        this.$refs.addDialog.openDialog("add", { 'type': 0, 'parentId': 0 })
      },
      handleAddTwo(data) {
        this.$refs.addDialogTwo.openDialog("add", { 'type': data.type + 1, 'parentId': data.id })
      },
      handleSizeChange(num) {
        this.queryParam.pageSize = num
        this.queryParam.pageNum = 1
        this.getList();
      },
      handleCurrentChange(num) {
        this.queryParam.pageNum = num
        this.getList();
      },
      showChildren(item) {
        this.$refs.childrenVisible.openDialog(item)
      },
      printBtn(data) {
        this.$refs.codePrint.visiblePrint = true
        this.$refs.codePrint.init('', data.id)
      },
      printAll() {
        this.$refs.codePrint.visiblePrint = true
        this.$refs.codePrint.init(this.queryParam.parentId, '')
      },
      closePrint() {
        this.printVisible = false
      },
      // 
      exportExcle(id) {
        console.log(id);
        let url = '';
        let params = {
          id: id
        }
        exportExcles(params).then(res => { 
          url = res.data
          if (url === '') {
            this.$message({
              type: 'error',
              message: '没有原材料数据'
            });
            return
          }
          console.log(url);
          let urls = baseUrl + url
          console.log(urls);
          const link = document.createElement('a');
          link.href = urls;

          link.style.display = 'none';
          link.download = '原材料清单.xlsx'; // 设置下载的文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);


        })

      },
      exportStockTakingExcle() {
        if (!this.stockTakingIds || this.stockTakingIds.length === 0) {
          this.$message({
            type: 'warning',
            message: '请勾选需要盘点的仓库'
          });
          return
        }
        this.stockTakingLoading = true
        exportStockTaking({ ids: this.stockTakingIds.join(',') }).then(res => {
          const url = res.data
          if (!url) {
            this.$message({
              type: 'error',
              message: '没有盘货数据'
            });
            return
          }
          const link = document.createElement('a');
          link.href = baseUrl + url;
          link.style.display = 'none';
          link.download = '盘货清单.xlsx';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.cancelStockTakingSelect()
        }).catch(() => {
        }).finally(() => {
          this.stockTakingLoading = false
        })
      },
      openStockTakingDialog() {
        this.stockTakingIds = []
        this.stockTakingDialogVisible = true
      },
      cancelStockTakingSelect() {
        this.stockTakingDialogVisible = false
        this.stockTakingIds = []
      },
      confirmStockTakingExport() {
        this.exportStockTakingExcle()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tabBox {
    min-height: 700px;
    width: 100%;
  }

  ::v-deep .tabBox .el-tabs__header {
    height: 100% !important;
    /* 设置你想要的高度 */
  }

  ::v-deep .tabBox .el-tabs__nav-wrap {
    height: 100% !important;
    /* 设置你想要的高度 */
  }

  ::v-deep .tabBox .el-tabs__active-bar {
    color: white !important;
    background-color: rgba(81, 205, 203, 0.1) !important;
  }

  ::v-deep .tabBox .el-tabs__nav-scroll {
    overflow-y: auto;
  }

  .areaBox {
    height: 500px;
    width: 100%;
  }

  ::v-deep .areaBox .el-tabs__header {
    height: 100% !important;
    /* 设置你想要的高度 */
  }

  ::v-deep .areaBox .el-tabs__nav-wrap {
    height: 100% !important;
    /* 设置你想要的高度 */
  }

  ::v-deep .areaBox .el-tabs__active-bar {
    color: white !important;
    background-color: rgba(81, 205, 203, 0.1) !important;
  }

  ::v-deep .areaBox .el-tabs__nav-scroll {
    overflow-y: auto;
  }

  .tab-body {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #f1f1f1;
    padding: 5px;
  }

  .tab-body-item {
    text-align: center;
  }

  .tab-body-item-top {
    font-size: 20px;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .tab-head .tab-head-top {
    font-size: 15px;
    font-weight: bold;
    margin-right: 20px;
  }

  .tab-area-head {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }

  img {
    width: 50px;
    height: auto;
  }

  .pageBox {
    display: flex;
    justify-content: flex-end;
  }

  .stock-taking-group {
    display: flex;
    flex-direction: column;
    max-height: 360px;
    overflow-y: auto;

    .el-checkbox {
      margin: 0 0 12px 0;
    }
  }

  .stock-taking-empty {
    color: #909399;
    text-align: center;
    padding: 20px 0;
  }

  .pa24 {
    padding: 24px 24px 0px 24px;
  }

  .kqTable {}
</style>